/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import { useState, useEffect } from "react"
import { Container, Row, Col } from "react-bootstrap"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import "bootstrap/dist/css/bootstrap.min.css"
import { cashFlowRubroDimensionResume, cashFlowRubroItemsResumeByDimension, cashFlowRubroItemsResumeByProject, cashFlowRubroResume, getProjetsByCompanyRequest, resetCashFlowGeneral, resetCashFlowPCGItemsReset, resetProjetsByCompanyRequest } from "../../actions/cash-flow.action"
import { useDispatch } from "react-redux"
import BudgetChart from "./BudgetChart"
import InputsGroup from "./InputsGroup"
import ChartAndTable from "./ChartAndTable"


ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend)

const CashFlowItem = () => {
	const dispatch = useDispatch();

  const [selectedCoin, setSelectedCoin] = useState("PEN")
  const [selectedCompany, setSelectedCompany] = useState("")
  const [mode, setMode] = useState("-1")
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  const [period, setPeriod] = useState("0")
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedRow, setSelectedRow] = useState('');

  useEffect(() => {
    if (!endDate) {
      return
    }
    setSelectedProject('')
    dispatch(resetProjetsByCompanyRequest())
    getProjetsByCompanyRequest(selectedCompany, startDate, endDate);
  }, [selectedCompany, startDate, endDate, mode])

  useEffect(() => {
    if (!endDate) {
      return
    }
    dispatch(resetCashFlowPCGItemsReset())
    if (mode === '-1') {
      cashFlowRubroItemsResumeByProject(endDate, selectedCompany, selectedProject)
    } else {
      cashFlowRubroItemsResumeByDimension(endDate, mode, selectedCompany, selectedProject)
    }
  }, [endDate, selectedCompany, mode, selectedProject])

  useEffect(() => {
    if (!endDate) {
      return
    }
    dispatch(resetCashFlowGeneral())
    if (mode === '-1') {
      cashFlowRubroResume(startDate, endDate, selectedCompany, selectedProject, period, selectedRow) 
    } else {
      cashFlowRubroDimensionResume(startDate, endDate, selectedCompany, period, selectedRow, mode, selectedProject)
    }
  }, [selectedCompany, startDate, endDate, period, selectedProject, selectedRow, mode])


  return (
    <Container fluid className="p-3" style={{height: '90%'}}>
        <InputsGroup
          selectedCoin={selectedCoin}
          setSelectedCoin={setSelectedCoin}
          selectedCompany={selectedCompany}
          setSelectedCompany={setSelectedCompany}
          mode={mode}
          setMode={setMode}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          period={period}
          setPeriod={setPeriod}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
        />

      <Row style={{height: '100%'}}>
        <Col md={4} style={{height: '90%', marginTop: '3em'}}>
          <BudgetChart
            title='Rubros'
            selectedCoin={selectedCoin}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            requiresStructure={false}
          />
        </Col>
        <Col md={8} style={{height: '100%'}}>
          <ChartAndTable
            startDate={startDate}
            endDate={endDate}
            selectedCoin={selectedCoin}
            selectedItem={selectedRow}
          />
        </Col>

      </Row>
    </Container>
  )
}

export default CashFlowItem
